import React, { Fragment } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface IProps {
  isAuthenticated?: boolean;
  userPermittedPaths?: string[];
  userDefaultPath?: string;
  children: React.ReactNode;
  [x: string]: any;
}

const AuthenticatedRoute = ({ isAuthenticated, userPermittedPaths = [], userDefaultPath = '', children, ...rest }: IProps) => {
  const location = useLocation();
  const isUserPermittedPath = userPermittedPaths.includes(location.pathname) || userPermittedPaths.includes('*');

  if (!isAuthenticated) {
    return <Navigate to={`/login?redirect=${location.pathname}${location.search}`} replace />;
  }

  if (userPermittedPaths.length === 0 || userDefaultPath === '') {
    return <Navigate to="/no-permissions" replace />;
  }

  if (!isUserPermittedPath) {
    return <Navigate to={userDefaultPath} replace />;
  }

  return <Fragment>{children}</Fragment>;
};

export default AuthenticatedRoute;
